// extracted by mini-css-extract-plugin
export default {"form_wrapper_no_border":"Goal-form_form_wrapper_no_border__vX7Sy"};